import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import { Button, TextField } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { getS11MapByKey, updateS11Map } from '../../../../api/s11Map'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'

function getEmpty() {
  return {
    key: '',
    fullName: '',
    url: '',
  }
}

export default function EditS11MapPage() {
  const [map, setMap] = useState(getEmpty())
  const mapKey = useParams().key
  const history = useHistory()
  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton()

  useEffect(() => {
    if (!mapKey) {
      alertError({ error: null, customMessage: 'Identificador de mapa no válido.' })
      history.push('/s11-maps')
      return
    }
    getS11MapByKey(mapKey)
      .then((res) => {
        if (res.status === 200) {
          setMap({
            key: res.data.key,
            fullName: res.data.fullName || '',
            url: res.data.url || '',
          })
          disableLoadingData()
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudo cargar el mapa S11.' })
        history.push('/s11-maps')
      })
  }, [mapKey, disableLoadingData, history])

  function save() {
    if (!map.fullName || !String(map.fullName).trim()) {
      alertError({ error: null, customMessage: 'El nombre es obligatorio.' })
      return
    }
    const url = String(map.url || '').trim()
    if (url) {
      try {
        const parsed = new URL(url)
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
          throw new Error('invalid protocol')
        }
      } catch {
        alertError({
          error: null,
          customMessage: 'La URL debe estar vacía o ser una URL http(s) absoluta.',
        })
        return
      }
    }
    updateS11Map(mapKey, {
      fullName: String(map.fullName).trim(),
      url,
    })
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({ title: 'Guardado', customMessage: 'Mapa S11 actualizado.' })
          history.push('/s11-maps')
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudo guardar.' })
      })
  }

  if (isLoadingData) return <ContentSkeleton />

  return (
    <>
      <Card>
        <CardHeader title={`Editar mapa S11 — ${map.key}`} />
        <CardBody>
          <TextField
            label="Identificador"
            value={map.key || ''}
            margin="normal"
            variant="outlined"
            fullWidth
            disabled
          />
          <TextField
            label="Nombre"
            value={map.fullName || ''}
            onChange={(e) => setMap({ ...map, fullName: e.target.value })}
            margin="normal"
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            label="URL S11"
            value={map.url || ''}
            onChange={(e) => setMap({ ...map, url: e.target.value })}
            margin="normal"
            variant="outlined"
            fullWidth
            helperText="Vacío = la app muestra el mapa OpenStreetMap. Si hay URL http(s) válida, se muestra en iframe."
          />
        </CardBody>
      </Card>
      <Button onClick={() => history.push('/s11-maps')} variant="outlined" style={{ marginRight: 20 }}>
        Volver
      </Button>
      <Button onClick={save} variant="outlined" color="primary">
        Guardar
      </Button>
    </>
  )
}
